import React from 'react'

import cx from 'classnames'

export default ({ children, elevation, className }) => {
  return <div className={cx('paper', className, !!elevation && `paper-${elevation}`)}>{children}</div>
}
